export default "__VITE_ASSET__dpCwdRX6__"